// ----------------------------------------------------------------------------
// Section: Stores
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Script
import Swiper, { Navigation, Keyboard } from 'swiper';
import 'snippets/icon/icon';

// Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/keyboard';
import './_stores.scss';
import { add } from 'lodash-es';


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const SWIPER_CLASS_SELECTOR  = '.swiper--stores';
const STORE_TITLE_SELECTOR   = '.stores--desktop .store__title';
const STORE_IMAGE_SELECTOR   = '.stores--desktop .store__image';
const STORE_ADDRESS_SELECTOR = '.stores--desktop .store__address';

// Classes
const SWIPER_CLASS = 'swiper--stores';
const ACTIVE_CLASS = 'js--is-active';


// -------------------------------------
// Helpers
// -------------------------------------

function initSlider() {
    const swiperContainers  = document.querySelectorAll(SWIPER_CLASS_SELECTOR);

    swiperContainers.forEach(function(container, index) {
        container.classList.add(SWIPER_CLASS + '-' + index);

        const swiper = new Swiper(SWIPER_CLASS_SELECTOR + '-' + index, {
            modules: [Navigation, Keyboard],
            slidesPerView: 1.25,
            spaceBetween: 10,
            autoHeight: true,
            observer: true,
            observeParents: true,
            watchOverflow: true,
            centeredSlides: true
        });

        swiper.slides.forEach(function(slide, index) {
            slide.addEventListener('focus', function() {
                swiper.slideTo(index);
            })
        });
    });
}

function initSelectors() {
    const storeTitles = document.querySelectorAll(STORE_TITLE_SELECTOR);

    storeTitles.forEach(function(title) {
        //title.tabIndex = 0;
        title.addEventListener('click', handleClick);
    });
}

function handleClick(event) {
    const storeTitles    = document.querySelectorAll(STORE_TITLE_SELECTOR);
    const storeImages    = document.querySelectorAll(STORE_IMAGE_SELECTOR);
    const storeAddresses = document.querySelectorAll(STORE_ADDRESS_SELECTOR);

    changeStore(event.currentTarget, storeTitles, storeImages, storeAddresses);
}

function changeStore(title, titles, images, addressess) {
    const image   = findResource(images, title);
    const address = findResource(addressess, title);

    if (image !== null && address !== null) {
        removeClassFromElements(titles, ACTIVE_CLASS);
        removeClassFromElements(images, ACTIVE_CLASS);
        removeClassFromElements(addressess, ACTIVE_CLASS);
        title.classList.add(ACTIVE_CLASS);
        image.classList.add(ACTIVE_CLASS);
        address.classList.add(ACTIVE_CLASS);
    } else {
        console.error('No matching image or address for title');
    }
}

function findResource(resources, title) {
    let resource = null;

    for (let i = 0; i < resources.length; i++) {
        if (resources[i].dataset.title === title.dataset.title) {
            resource = resources[i];
            break;
        }
    }

    return resource;
}

function removeClassFromElements(elems, className) {
    elems.forEach(function(elem) {
        elem.classList.remove(className);
    });
}


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    const media = window.matchMedia('(max-width: 679px)');

    if (media.matches) {
        initSlider();
    } else {
        initSelectors();
    }
});

window.addEventListener('resize', function () {
    const media = window.matchMedia('(max-width: 679px)');

    if (media.matches) {
        initSlider();
    } else {
        initSelectors();
    }
});
